
export const getEnvConfigs = () => {

  // console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`)

  const {
    REACT_APP_VERSION: appVersion,
    REACT_APP_NAME: appName,
    // REACT_APP_API_BASE_URL: appApiBaseUrl,
    REACT_APP_API_PRODUCTION_BASE_URL: appApiProductionBaseUrl,
    REACT_APP_API_PRODUCTION_V2_BASE_URL: appApiProductionV2BaseUrl,
    REACT_APP_API_DEVELOPMENT_BASE_URL: appApiDevelopmentBaseUrl,
    REACT_APP_API_DEVELOPMENT_V2_BASE_URL: appApiDevelopmentBaseV2Url,
    REACT_APP_ENVIROMENT: appEnviroment,
  } = process.env

  // console.log('process.env', process.env)

  let appIsEnviromentDevelopment = Boolean(appEnviroment.toLowerCase() === 'development')
  let appIsEnviromentProduction = Boolean(appEnviroment.toLowerCase() === 'production')

  let AppApiUrl = ''
  let AppApiV2Url = ''

  if (appIsEnviromentDevelopment) {
    AppApiUrl = appApiDevelopmentBaseUrl
    AppApiV2Url = appApiDevelopmentBaseV2Url
  } else {
    AppApiUrl = appApiProductionBaseUrl
    AppApiV2Url = appApiProductionV2BaseUrl
  }

  /** Load Custom Env */
  let customEnv = {}
  Object.keys(process.env).forEach(i => {
    if (i.toLowerCase().startsWith('react_app_custom_')) {

      let newField = i.replace(/(react_app_custom_)/gmi, '')

      customEnv = {
        ...customEnv,
        [newField]: process.env[i]
      }

    }
  })

  return {
    appVersion,
    appName,
    // appApiBaseUrl,
    AppApiUrl,
    AppApiV2Url,
    appApiProductionBaseUrl,
    appApiDevelopmentBaseUrl,
    appEnviroment,
    appIsEnviromentDevelopment,
    appIsEnviromentProduction,
    ...customEnv
  }
}